export default __webpack_public_path__ + "static/media/DNo.26-3.a1619b2a.jpg";